var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormulateInput',{attrs:{"label":"Příjmení","type":"text","name":"lastName","value":_vm.value,"help":_vm.help,"validation":"bail|alphaExtendedSpecial|emptyOrMin:2|max:20,length","validation-messages":{
    alphaExtendedSpecial: 'Povolené jsou pouze znaky abecedy',
    emptyOrMin: 'Příjmení musí obsahovat minimálně 2 znaky',
    max: 'Příjmení je omezeno na maximálně 20 znaků',
  },"error-behavior":"submit","disabled":_vm.disabled}})
}
var staticRenderFns = []

export { render, staticRenderFns }